/**
 * Constants
 */

export const SET_ERRORS = 'site@SET_ERRORS';
export const RESET_REQUEST = 'site@RESET_REQUEST';
export const SET_PAGE = 'site@SET_PAGE';
export const SET_MENU_OPEN = 'site@SET_MENU_OPEN';
export const SET_SPLASH = 'site@SET_SPLASH';

/**
 * Actions creator
 */
export const setErrors = payload => ({
    type: SET_ERRORS,
    payload,
});

export const resetErrors = () => ({
    type: SET_ERRORS,
    payload: null,
});

export const resetRequest = () => ({
    type: RESET_REQUEST,
});

export const setPage = (pageUrl, payload) => ({
    type: SET_PAGE,
    payload: {
        ...payload,
        url: pageUrl,
    },
});

export const setMenuOpen = payload => ({
    type: SET_MENU_OPEN,
    payload,
});

export const setSplash = payload => ({
    type: SET_SPLASH,
    payload,
});
